import * as React from 'react'
import usePagination from '@mui/material/usePagination'

import Icon from '../UI/Icon'

import './pagination.css'

export default function UsePagination({
  count = 9,
  onChange = () => {},
  answeredQuestions,
  page = 1,
  altColors = false,
  loading = false,
  siblingCount = 10,
  total,
  ...props
}) {
  const { items } = usePagination({
    count,
    onChange,
    page,
    siblingCount,
    ...props,
  })

  const pageSize = 10

  return (
    <nav className="paginationContainer flex my-2 justify-content-center">
      <ul className="flex">
        {items.map(({ page, type, selected, ...item }, index) => {
          let isAnswered = answeredQuestions?.some(({ position }) => position + 1 == page)

          let children

          if (type === 'page' || type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = (
              <button
                type="button"
                className={`py-2 px-3 mx-2 flex rounded disabled:opacity-50 transition-all duration-200 ease ${selected ? (altColors ? '!bg-primary-button hover:!bg-primary-button-hover text-white' : 'bg-[#FEEBDD] text-primary-100') : altColors ? 'text-primary-button' : isAnswered ? 'bg-none text-white' : 'bg-[#feebdd73] text-primary-100'}`}
                {...item}
                disabled={!!item.disabled || loading}
              >
                {type === 'start-ellipsis' || type === 'end-ellipsis' ? '...' : page}
              </button>
            )
          } else {
            children = (
              <div className="flex items-center h-full">
                {type === 'next' && (
                  <button
                    disabled={total - pageSize < page}
                    onClick={(e) => onChange(e, page + pageSize)}
                    className={`h-full items-center justify-center px-3 mx-2 flex rounded transition-all duration-200 ease bg-[#feebdd] !border-gray-200 border`}
                  >
                    <Icon
                      name="arrow-left-line-short"
                      color={altColors ? '#fff' : '#F67443'}
                      className="w-[20px] h-[20px] mr-2 rotate-180"
                    />
                  </button>
                )}
                <button
                  type="button"
                  {...item}
                  disabled={!!item.disabled || loading}
                  className={`inline-flex items-center justify-center h-full px-[14px] rounded-lg disabled:opacity-50 transition-all duration-200 ease ${altColors ? '!bg-primary-button hover:!bg-primary-button-hover' : 'bg-[#feebdd] !border-gray-200 border'}`}
                >
                  {type === 'previous' ? (
                    <>
                      <Icon
                        name="arrow-left-line-short"
                        color={altColors ? '#fff' : '#F67443'}
                        className="w-[20px] h-[20px] mr-2"
                      />

                      <span
                        className={`upcomingUserDetailsValueName font-semibold text-capitalize ${altColors ? 'text-white' : 'text-primary-100'}`}
                      >
                        {type}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        className={`upcomingUserDetailsValueName font-semibold text-capitalize mr-2 ${altColors ? 'text-white' : 'text-primary-100'}`}
                      >
                        {type}
                      </span>

                      <Icon
                        name="arrow-left-line-short"
                        color={altColors ? '#fff' : '#F67443'}
                        className="w-[20px] h-[20px] rotate-180"
                      />
                    </>
                  )}
                </button>

                {type === 'previous' && (
                  <button
                    onClick={(e) => onChange(e, page - pageSize)}
                    disabled={page <= pageSize}
                    className={`h-full flex items-center justify-center px-3 mx-2  rounded transition-all duration-200 ease bg-[#feebdd] !border-gray-200 border`}
                  >
                    <Icon
                      name="arrow-left-line-short"
                      color={altColors ? '#fff' : '#F67443'}
                      className="w-[20px] h-[20px] mr-2"
                    />
                  </button>
                )}
              </div>
            )
          }

          return (
            <li key={index} className="hover:cursor-pointer">
              {children}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
